import { render, staticRenderFns } from "./RegraCondicional.vue?vue&type=template&id=069752ae&scoped=true"
import script from "./RegraCondicional.vue?vue&type=script&lang=js"
export * from "./RegraCondicional.vue?vue&type=script&lang=js"
import style0 from "./RegraCondicional.vue?vue&type=style&index=0&id=069752ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069752ae",
  null
  
)

export default component.exports